import React, { useEffect, useState, useCallback } from "react";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import './UsersList.css';
import { useNavigate } from 'react-router-dom'; // Import useNavigate
import TopBar from "./TopBar";
import { Col, Container, Form, Row } from "react-bootstrap";
import { fetchPranthList } from './pranthService'; // Adjust path as needed
import useAuth from "../../hooks/useAuth";
import { BrowserRouter as Router, Routes, Route, useParams } from 'react-router-dom';
import customFont from './NotoSansMalayalam-VariableFont_wdth,wght-normal.js';



const AdminGurudakshinaSummary = () => {

  const [summaryType, setSummaryType] = useState("KHAND");
  const [gurudakshinas, setGurudakshinas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const gurudakshinasPerPage = 15;
  const axiosPrivate = useAxiosPrivate();
  const navigate = useNavigate();
  const { auth } = useAuth();

  const [selectedArthiksakhasId, setSelectedArthiksakhasId] = useState(auth.level_id);

  const [selectedSthanId, setSelectedSthanId] = useState("");
  const [sthanList, setSthanList] = useState([]);

  const [sakhaList, setSakhaList] = useState([]);

  const [selectedKhandId, setSelectedKhandId] = useState("");
  const [khandList, setKhandList] = useState([]);

  const [mandalamList, setMandalamList] = useState([]);
  const [selectedMandalamId, setSelectedMandalamId] = useState("");
  const [Sthans, setSthans] = useState([]);

  const [hasSearched, setHasSearched] = useState(false); // 👈 NEW






  // const searchList = async () => {
  //   try {
  //     let summaryTypeParam = "";
  //     let url = "/gurudakshina-summary?";
  //     setLoading(true);
  //     setHasSearched(true);

  //     switch (summaryType) {

  //       case "KHAND":
  //         summaryTypeParam = `summary_type=KHAND` +
  //           `&khand_id=${selectedKhandId}` +
  //           `&mandal_id=${selectedMandalamId}` +
  //           `&sthan_id=${selectedSthanId}`;
  //         break;


  //       case "MANDAL":
  //         summaryTypeParam = `summary_type=STHAN` +
  //           `&mandal_id=${selectedMandalamId}` +
  //           `&sthan_id=${selectedSthanId}`;
  //         break;

  //       case "STHAN":
  //         summaryTypeParam = `summary_type=STHAN` +
  //           `&sthan_id=${selectedSthanId}`;
  //         break;

  //       default:
  //         alert("Please select a Summary Type");  // show message
  //         return;
  //     }

  //     const res = await axiosPrivate.get(`${url}${summaryTypeParam}`);
  //     setGurudakshinas(res.data);
  //     setLoading(false);
  //   } catch (err) {
  //     console.error("Failed to search", err);
  //     setLoading(false);
  //   }
  // };

  const searchList = async () => {
    try {
      let summaryTypeParam = "";
      let url = "/gurudakshina-summary?";

      setLoading(true);
      setHasSearched(true);

      // Summary Type is mandatory
      if (!summaryType) {
        alert("Please select a Summary Type");
        setLoading(false);
        return;
      }

      switch (summaryType) {
        case "KHAND":
          if (!selectedKhandId) {
            alert("Please select a Khand");
            setLoading(false);
            return;
          }

          summaryTypeParam =
            `summary_type=KHAND` +
            `&khand_id=${selectedKhandId}` +
            `&mandal_id=${selectedMandalamId}` +
            `&sthan_id=${selectedSthanId}`;
          break;

        case "MANDAL":
          if (!selectedMandalamId) {
            alert("Please select a Mandalam");
            setLoading(false);
            return;
          }

          summaryTypeParam =
            `summary_type=MANDAL` +
            `&mandal_id=${selectedMandalamId}` +
            `&sthan_id=${selectedSthanId}`;
          break;

        case "STHAN":
          if (!selectedSthanId) {
            alert("Please select a Sthan");
            setLoading(false);
            return;
          }

          summaryTypeParam =
            `summary_type=STHAN` +
            `&sthan_id=${selectedSthanId}`;
          break;

        default:
          alert("Please select a Summary Type");
          setLoading(false);
          return;
      }

      const res = await axiosPrivate.get(`${url}${summaryTypeParam}`);
      setGurudakshinas(res.data);
      setLoading(false);
    } catch (err) {
      console.error("Failed to search", err);
      setLoading(false);
    }
  };


  useEffect(() => {
    const fetchSthanList = async () => {
      if (!selectedMandalamId) {
        setSthanList([]);
        setSelectedSthanId("");
        return;
      }

      setLoading(true);
      try {
        const res = await axiosPrivate.get(`list-sthans?mandal_id=${selectedMandalamId}`);
        const data = Array.isArray(res.data) ? res.data : [];
        setSthanList(data);
        if (data.length > 0) {
          const firstSthanId = "";
          setSelectedSthanId("");  // force change
          setTimeout(() => {
            setSelectedSthanId(firstSthanId);  // re-trigger useEffect
          }, 0);
        } else {
          setSelectedSthanId("");
          setSthans([]); // clear table
        }

      } catch (err) {
        console.error("Sthan fetch failed:", err);
        setError("Failed to load Sthan list");
        setSthanList([]);
        setSelectedSthanId("");
        setSthans([]);
      } finally {
        setLoading(false);
      }
    };

    fetchSthanList();
  }, [selectedMandalamId]);

  useEffect(() => {
    const fetchMandalamList = async () => {
      if (!selectedKhandId) {
        setMandalamList([]);
        setSelectedMandalamId("");
        setSthans([]); // clear table
        return;
      }

      setLoading(true);
      try {
        const res = await axiosPrivate.get(`list-mandals?khand_id=${selectedKhandId}`);
        const data = Array.isArray(res.data) ? res.data : [];
        setMandalamList(data);
        if (data.length > 0) {
          const firstMandalamId = data[0].mandal_id;
          setSelectedMandalamId("");  // force change
          setTimeout(() => {
            setSelectedMandalamId(firstMandalamId);  // re-trigger useEffect
          }, 0);
        } else {
          setSelectedMandalamId("");
          setSthans([]); // clear table
        }

      } catch (err) {
        console.error("Sthan fetch failed:", err);
        setError("Failed to load Sthan list");
        setMandalamList([]);
        setSelectedMandalamId("");
        setSthans([]);
      } finally {
        setLoading(false);
      }
    };

    fetchMandalamList();
  }, [selectedKhandId]);

  const fetchKhands = useCallback(async () => {
    if (!selectedArthiksakhasId) return;

    setLoading(true);
    // setMandalams([]);
    try {
      const res = await axiosPrivate.get(`list-khands-in-arthik-sakha?arthik_sakha_id=${selectedArthiksakhasId}`);
      const data = Array.isArray(res.data) ? res.data : [];
      setKhandList(data);
      if (data.length > 0) {
        const firstKhandId = "";
        setSelectedKhandId("");            // <- force a change
        setTimeout(() => {
          setSelectedKhandId(firstKhandId);  // <- this will retrigger the useEffect
        }, 0);
      }
    } catch (err) {
      console.error("Khand fetch failed:", err);
      setError("Failed to load Khand list");
      setKhandList([]);
      setSelectedKhandId("");
    } finally {
      setLoading(false);
    }
  }, [axiosPrivate, selectedArthiksakhasId]);


  useEffect(() => {
    fetchKhands();
  }, [selectedArthiksakhasId]);

  useEffect(() => {
    const fetchMandalamList = async () => {
      if (!selectedKhandId) {
        setMandalamList([]);
        setSelectedMandalamId("");
        setSthans([]); // clear table
        return;
      }

      try {
        const res = await axiosPrivate.get(`list-mandals?khand_id=${selectedKhandId}`);
        const data = Array.isArray(res.data) ? res.data : [];
        setMandalamList(data);
        if (data.length > 0) {
          const firstMandalamId = "";
          setSelectedMandalamId("");  // force change
          setTimeout(() => {
            setSelectedMandalamId(firstMandalamId);  // re-trigger useEffect
          }, 0);
        } else {
          setSelectedMandalamId("");
          setSthans([]); // clear table
        }

      } catch (err) {
        console.error("Sthan fetch failed:", err);
        setError("Failed to load Sthan list");
        setMandalamList([]);
        setSelectedMandalamId("");
        setSthans([]);
      } finally {
        setLoading(false);
      }
    };

    fetchMandalamList();
  }, [selectedKhandId]);


  useEffect(() => {
    setGurudakshinas([]);
    setHasSearched(false);
  }, [summaryType, selectedArthiksakhasId, selectedKhandId, selectedMandalamId, selectedSthanId]);





  const handleViewClick = (gurudakshinaId) => {
    // Navigate to the GetFranchise component with franchiseId as a URL parameter
    navigate(`/view/gurudakshina/${gurudakshinaId}`);
  };
  const handleEditClick = (gurudakshinaId) => {
    navigate(`/edit/gurudakshina/${gurudakshinaId}`);
  }


  const indexOfLastGurudakshina = currentPage * gurudakshinasPerPage;
  const indexOfFirstGurudakshina = indexOfLastGurudakshina - gurudakshinasPerPage;
  const currentGurudakshina = gurudakshinas.slice(indexOfFirstGurudakshina, indexOfLastGurudakshina);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const totalPages = Math.ceil(gurudakshinas.length / gurudakshinasPerPage);

  // if (loading) {
  //   return <div className="loading">Loading...</div>;
  // }

  // if (error) {
  //   return <div className="error">{error}</div>;
  // }


  const exportPDF = () => {
    const { jsPDF } = window.jspdf;
    const doc = new jsPDF();

    // Add custom font
    doc.addFileToVFS("NotoSansMalayalam.ttf", customFont);
    doc.addFont("NotoSansMalayalam.ttf", "NotoSansMalayalam", "normal");
    doc.setFont("NotoSansMalayalam");

    doc.text("Gurudakshina Summary Report", 14, 10); // Example Malayalam text

    // Example: dynamic table headings from variables
    const khandLabel = "Khand";
    const mandalLabel = "Mandal";
    const sthanLabel = "Sthan";

    const headers = [
      [
        "Khand",
        "Mandal",
        "Sthan",
        { content: "Vidyarthi Samyuktha", colSpan: 2, styles: { halign: "center" } },
        { content: "Vidyarthi Tharuna", colSpan: 2, styles: { halign: "center" } },
        { content: "Vyavasayi Tharuna", colSpan: 2, styles: { halign: "center" } },
        { content: "Prouda", colSpan: 2, styles: { halign: "center" } },
        { content: "Total", colSpan: 2, styles: { halign: "center" } }
      ],
      ["", "", "", "Upa", "Amt", "Upa", "Amt", "Upa", "Amt", "Upa", "Amt", "Upa", "Amt"]
    ];

    const data = gurudakshinas.map(item => [
      item.khand_name,
      item.mandal_name,
      item.sthan_name,

      // Vidyarthi Samyuktha
      item.VISUpasthith,
      item.VISAmount,

      // Vidyarthi Tharuna
      item.VITUpasthith,
      item.VITAmount,

      // Vyavasayi Tharuna
      item.VYTUpasthith,
      item.VYTAmount,

      // Prouda
      item.PUpasthith,
      item.PAmount,

      // Total
      item.TotalUpasthith,
      item.TotalaAmount
    ]);


    doc.autoTable({
      head: headers,
      body: data,
      startY: 20,
      styles: { fontSize: 6, font: "NotoSansMalayalam" },
      headStyles: {
        font: "NotoSansMalayalam",
        fillColor: [0, 0, 0],
        textColor: [255, 255, 255],
        halign: 'center'
      }
    });



    doc.save("gurudakshina_summary_report.pdf");
  };







  return (
    <>
      <style>
        {`
        #customers th, #customers td {
          min-width: 100px;
        }
      `}
      </style>
      {/* <Container> */}
      <section className="empbody">
        <div className="wrapperemp2">

          <div className="d-flex justify-content-end align-items-center gap-2 mb-3">
            <button onClick={() => navigate(-1)} className="btn btn-secondary newviewbtn"> ← Back</button>

            <button
              type="button"
              className="btn btn-success ms-auto newviewbtn"
              onClick={exportPDF}
            >
              Download PDF
            </button>
          </div>
          {/* <button onClick={handleRedirect} type="button" className="btn btn-success ms-auto d-block top-bt">+ Create Vibhag</button> */}
          <h3>Gurudakshina Summary Report</h3>




          <Row className="mb-3 newrowstyle" style={{ justifyContent: "normal  !important;" }}>
            <Col md={2}>
              <Form.Label className="newformstyle">Summary Type</Form.Label>
              <Form.Select
                className="newselectstyle"
                value={summaryType}
                onChange={(e) => {
                  setSummaryType(e.target.value);

                  // Reset dependent dropdowns
                  setSelectedKhandId("");
                  setSelectedMandalamId("");
                  setSelectedSthanId("");
                  setMandalamList([]);
                  setSthanList([]);
                }}
              >
                <option value="">-- Select Summary Type --</option>
                <option value="KHAND">Khand</option>
                <option value="MANDAL">Mandalam</option>
                <option value="STHAN">Sthan</option>
              </Form.Select>
            </Col>

            {/* Show for KHAND, MANDAL and STHAN */}
            {["KHAND", "MANDAL", "STHAN"].includes(summaryType) && (
              <Col md={2}>
                <Form.Label className="newformstyle">Khand</Form.Label>
                <Form.Select
                  className="newselectstyle"
                  value={selectedKhandId}
                  onChange={(e) => setSelectedKhandId(e.target.value)}
                  disabled={!khandList.length}
                >
                  <option value="">-- Select Khand --</option>
                  {khandList.map((k) => (
                    <option key={k.khand_id} value={k.khand_id}>
                      {k.khand_name}
                    </option>
                  ))}
                </Form.Select>
              </Col>
            )}

            {/* Show only for MANDAL and STHAN */}
            {["MANDAL", "STHAN"].includes(summaryType) && (
              <Col md={2}>
                <Form.Label className="newformstyle">Mandalam</Form.Label>
                <Form.Select
                  className="newselectstyle"
                  value={selectedMandalamId}
                  onChange={(e) => setSelectedMandalamId(e.target.value)}
                  disabled={!selectedKhandId || !mandalamList.length}
                >
                  <option value="">-- Select Mandalam --</option>
                  {mandalamList.map((m) => (
                    <option key={m.mandal_id} value={m.mandal_id}>
                      {m.mandal_name}
                    </option>
                  ))}
                </Form.Select>
              </Col>
            )}

            {/* Show only for STHAN */}
            {summaryType === "STHAN" && (
              <Col md={2}>
                <Form.Label className="newformstyle">Sthan</Form.Label>
                <Form.Select
                  className="newselectstyle"
                  value={selectedSthanId}
                  onChange={(e) => setSelectedSthanId(e.target.value)}
                  disabled={!selectedMandalamId || !sthanList.length}
                >
                  <option value="">-- Select Sthan --</option>
                  {sthanList.map((s) => (
                    <option key={s.sthan_id} value={s.sthan_id}>
                      {s.sthan_name}
                    </option>
                  ))}
                </Form.Select>
              </Col>
            )}


            <Col md={2} className="d-flex align-items-end">
              <button type="button" className="btn orange_btn newbtnstyles" onClick={searchList} >
                Search
              </button>
            </Col>

          </Row>

          <div className="table-container">
            {hasSearched && (
              <table id="customers">
                <thead>
                  <tr>
                    <th>Khand</th>
                    <th>Mandal</th>
                    <th>Sthan</th>

                    <th colSpan="2">Vidyarthi Samyuktha</th>
                    <th colSpan="2">Vidyarthi Tharuna</th>

                    <th colSpan="2">Vyavasayi Tharuna</th>
                    <th colSpan="2">Prouda</th>
                    <th colSpan="2">Total</th>
                  </tr>
                  <tr>
                    <th colSpan="3"></th>
                    <th>Upasthiti</th><th>Amount</th>
                    <th>Upasthiti</th><th>Amount</th>
                    <th>Upasthiti</th><th>Amount</th>
                    <th>Upasthiti</th><th>Amount</th>
                    <th>Upasthiti</th><th>Amount</th>
                  </tr>
                </thead>

                <tbody>
                  {loading ? (
                    <tr>
                      <td colSpan="16" className="text-center text-primary">
                        Loading...
                      </td>
                    </tr>
                  ) : error ? (
                    <tr>
                      <td colSpan="13" className="text-danger text-center">{error}</td>
                    </tr>
                  ) : gurudakshinas.length === 0 ? (
                    <tr>
                      <td colSpan="13">No Data available.</td>
                    </tr>
                  ) : (
                    currentGurudakshina.map(g => (
                      <tr key={g.id}>
                        <td>{g.khand_name}</td>
                        <td>{g.mandal_name}</td>
                        <td>{g.sthan_name}</td>

                        <td>{g.VISUpasthith}</td>
                        <td>{g.VISAmount}</td>

                        <td>{g.VITUpasthith}</td>
                        <td>{g.VITAmount}</td>

                        <td>{g.VYTUpasthith}</td>
                        <td>{g.VYTAmount}</td>

                        <td>{g.PUpasthith}</td>
                        <td>{g.PAmount}</td>

                        <td>{g.TotalUpasthith}</td>
                        <td>{g.TotalaAmount}</td>
                      </tr>
                    ))
                  )}
                </tbody>

                {/* ✅ Totals Row should always be inside table but after tbody */}
                {gurudakshinas.length > 0 && (
                  <tfoot>
                    <tr>
                      <th colSpan="3">Total</th><td>
                        <b>{gurudakshinas.reduce((s, g) => s + (g.VISUpasthith || 0), 0)}</b>
                      </td>
                      <td>
                        <b>{gurudakshinas.reduce((s, g) => s + (g.VISAmount || 0), 0)}</b>
                      </td>

                      <td>
                        <b>{gurudakshinas.reduce((s, g) => s + (g.VITUpasthith || 0), 0)}</b>
                      </td>
                      <td>
                        <b>{gurudakshinas.reduce((s, g) => s + (g.VITAmount || 0), 0)}</b>
                      </td>
                      <td><b>{gurudakshinas.reduce((s, g) => s + (g.VYTUpasthith || 0), 0)}</b></td>
                      <td><b>{gurudakshinas.reduce((s, g) => s + (g.VYTAmount || 0), 0)}</b></td>
                      <td><b>{gurudakshinas.reduce((s, g) => s + (g.PUpasthith || 0), 0)}</b></td>
                      <td><b>{gurudakshinas.reduce((s, g) => s + (g.PAmount || 0), 0)}</b></td>
                      <td><b>{gurudakshinas.reduce((s, g) => s + (g.TotalUpasthith || 0), 0)}</b></td>
                      <td><b>{gurudakshinas.reduce((s, g) => s + (g.TotalaAmount || 0), 0)}</b></td>
                    </tr>
                  </tfoot>
                )}
              </table>
            )}
          </div>
          <div className="table-container">
            {totalPages > 1 && (
              <div className="pagination">
                <button onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1}>Previous</button>
                {Array.from({ length: totalPages }, (_, index) => (
                  <button
                    key={index}
                    onClick={() => handlePageChange(index + 1)}
                    disabled={currentPage === index + 1}
                  >
                    {index + 1}
                  </button>
                ))}
                <button onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages}>Next</button>
              </div>
            )}
          </div>
        </div>
      </section >
      <TopBar />
      {/* </Container> */}
    </>
  );
};

export default AdminGurudakshinaSummary;